import { IconButton } from '@mui/material';
import Iconify from '../Iconify';

const AXES = {
  vertical: {
    earlier: 'up',
    later: 'down',
    earlierLabel: 'Plus haut',
    laterLabel: 'Plus bas',
    earlierIcon: 'material-symbols:arrow-upward',
    laterIcon: 'material-symbols:arrow-downward',
  },
  horizontal: {
    earlier: 'left',
    later: 'right',
    earlierLabel: 'À gauche',
    laterLabel: 'À droite',
    earlierIcon: 'material-symbols:arrow-back',
    laterIcon: 'material-symbols:arrow-forward',
  },
};

const OrderMoveButtons = ({ axis = 'vertical', onMove, disableUp = false, disableDown = false }) => {
  const labels = AXES[axis] || AXES.vertical;
  const move = (event, direction) => {
    event.stopPropagation();
    event.preventDefault();
    onMove(direction);
  };

  return (
    <>
      <IconButton
        aria-label={labels.earlierLabel}
        size="small"
        disabled={disableUp}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => move(event, labels.earlier)}
      >
        <Iconify icon={labels.earlierIcon} />
      </IconButton>
      <IconButton
        aria-label={labels.laterLabel}
        size="small"
        disabled={disableDown}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => move(event, labels.later)}
      >
        <Iconify icon={labels.laterIcon} />
      </IconButton>
    </>
  );
};

export default OrderMoveButtons;
